import axios from 'axios';
import { BASE_URL } from 'consts/APIUrls';
import Cookies from 'js-cookie';

export const createAPI = () => {

  const api = axios.create({
    baseURL: BASE_URL,
  });

  api.interceptors.request.use(
    (config) => {
      const token = Cookies.get('token');
      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
      }

      return config;
    },
  );

  return api;
};
